/**
 * Single Transaction History Item Model
 */

define(function(require, exports, module) {
    'use strict';

    const BaseModel = require('common/base.model');
    const i18n = require('i18n');

    module.exports = BaseModel.extend({

        idAttribute: 'code',

        toJSON: function(options = {}) {
            const data = BaseModel.prototype.toJSON.call(this);
            const { getDateTimeShort, formatCurrency } = window.Playtech.API.formatter;
            const {
                amount: {
                    amount,
                    currencyCode
                },
                balanceChanges,
                transactionDateInUms,
                participationStartDate
            } = data;
            const isFreeSpins = currencyCode === 'XXX';
            const translate = tk => i18n.t(`playtech.mobile.system.mobile-cashier.transaction-history.${tk}`);

            data.transactionDateInUms = getDateTimeShort(transactionDateInUms);

            if (data.participationStartDate) {
                data.participationStartDate = getDateTimeShort(participationStartDate);
            }

            if (isFreeSpins) {
                return {
                    ...data,
                    amount: `${amount} ${translate(`freeSpins.${Math.abs(amount) > 1 ? 'many' : 'one'}`)}`,
                    balance: ''
                };
            }
            const {
                balanceAfter
            } = balanceChanges.find(({ balanceType }) => balanceType === 'casino_gaming_balance') || {};
            const formatterOptions = options.forCsv
                ? {
                    thSeparator: '',
                    decSeparator: '.',
                    precision: null
                }
                : {};

            data.amount = formatCurrency(amount, {
                ...formatterOptions,
                currencyCode
            });

            data.balance = balanceAfter && formatCurrency(balanceAfter.amount, {
                ...formatterOptions,
                currencyCode: balanceAfter.currencyCode
            });

            return data;
        }
    });
});
